var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { EntityBubbleImage, EntityTypeCountIcon, useEntityTypeCountIcons } from '@shapeable/ui';
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { CircleMenu, CircleMenuItem } from 'react-circular-menu';
import { get, findIndex } from 'lodash';
import { MapPopup } from '../elements/map-popup';
import { classNames } from '@shapeable/utils';
import { useEntityTypeMapMarkers } from '../hooks/use-entity-type-map-markers';
import { EntityMapMarker } from './entity-map-marker';
var cls = classNames('entity-circle-menu');
export var EntityCircleMenuDefaultProps = {
  items: [],
  size: 48
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    /* Override CircleMenu Props */\n    /* TODO - steal the radial logic and ditch this component, it's not very customisable */\n\n    \n\n    button {\n      cursor: default;\n    }\n\n    button:hover {\n      transition: 0s;\n      color: ", ";\n      background: ", ";\n    }\n\n    li {\n      cursor: default;\n      transition: all 0.3s;\n\n      ", "\n    }\n  "], ["\n    /* Override CircleMenu Props */\n    /* TODO - steal the radial logic and ditch this component, it's not very customisable */\n\n    \n\n    button {\n      cursor: default;\n    }\n\n    button:hover {\n      transition: 0s;\n      color: ", ";\n      background: ", ";\n    }\n\n    li {\n      cursor: default;\n      transition: all 0.3s;\n\n      ", "\n    }\n  "])), theme.COLOR('dark'), theme.COLOR('light'), function (_a) {
    var selectedIndex = _a.selectedIndex;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        &:nth-child(", ") {\n          z-index: 200;\n        }\n        \n      "], ["\n        &:nth-child(", ") {\n          z-index: 200;\n        }\n        \n      "])), selectedIndex + 1);
  })
});
var CountStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n\n    &:hover {\n      ", ";\n    }\n  "], ["\n    ", ";\n\n    &:hover {\n      ", ";\n    }\n  "])), theme.FILL('light'), theme.FILL('strong'))
});
var MenuItemStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: relative;\n    z-index: 150;\n    background: none;\n    text-align: left; /* Fixes alignment in tooltips when they are shown */\n\n    ", "\n  "], ["\n    position: relative;\n    z-index: 150;\n    background: none;\n    text-align: left; /* Fixes alignment in tooltips when they are shown */\n\n    ", "\n  "])), function (props) {
    return props.isSelected && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      li {\n        z-index: 150;\n      }      \n    "], ["\n      li {\n        z-index: 150;\n      }      \n    "])));
  })
});
var PopupContainerStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    position: absolute;\n    height: 0;\n    width: 0;\n    z-index: 100; \n    overflow: visible;\n    z-index: 600;\n    min-width: 260px;\n  "], ["\n    position: absolute;\n    height: 0;\n    width: 0;\n    z-index: 100; \n    overflow: visible;\n    z-index: 600;\n    min-width: 260px;\n  "])))
});
var PopupStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    transform: translateX(-50%);\n    overflow: visible;\n    position: absolute;\n    bottom: 10px;\n    left: 0;\n    ", "\n    margin-bottom: ", ";\n\n    button {\n      cursor: pointer;\n    }\n  "], ["\n    transform: translateX(-50%);\n    overflow: visible;\n    position: absolute;\n    bottom: 10px;\n    left: 0;\n    ", "\n    margin-bottom: ", ";\n\n    button {\n      cursor: pointer;\n    }\n  "])), function (props) {
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      left: ", "px;\n    "], ["\n      left: ", "px;\n    "])), props.size / 2);
  }, theme.UNIT(4))
});
var BubbleStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    cursor: pointer;\n  "], ["\n    cursor: pointer;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Count: styled(EntityTypeCountIcon)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), CountStyles),
  MenuItem: styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), MenuItemStyles),
  Bubble: styled(EntityBubbleImage).attrs(cls.attr('bubble'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BubbleStyles),
  PopupContainer: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), PopupContainerStyles),
  Popup: styled(MapPopup)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), PopupStyles)
};
export var EntityCircleMenu = function (props) {
  var className = props.className,
    size = props.size,
    items = props.items,
    selectedEntity = props.selectedEntity,
    bubbleComponent = props.bubbleComponent,
    popup = props.popup,
    onClose = props.onClose,
    onMenuToggle = props.onMenuToggle,
    onSelect = props.onSelect,
    entityTypeName = props.entityTypeName,
    pinSize = props.pinSize,
    imageStyle = props.imageStyle;
  var _a = __read(React.useState(false), 2),
    isOpen = _a[0],
    setIsOpen = _a[1];
  var sizeFactor = items.length < 10 ? 1 : items.length > 20 ? 3 : 1.5;
  var handleToggle = function (isOpen) {
    setIsOpen(isOpen);
    if (onMenuToggle) {
      onMenuToggle(isOpen);
    }
  };
  var Markers = useEntityTypeMapMarkers();
  // I have no way to select the "li" tags from CircleMenu, so need to use nth selector! ARGHHHH.
  var selectedIndex = findIndex(items, function (item) {
    return item.id === get(selectedEntity, 'id');
  });
  var radius = size * sizeFactor / 10;
  var Bubble = bubbleComponent || My.Bubble;
  var entityTypeNames = items.map(function (item) {
    return item.__typename;
  });
  var countIcons = useEntityTypeCountIcons();
  var Count = entityTypeNames.length === 1 ? countIcons[entityTypeName] || EntityTypeCountIcon : EntityTypeCountIcon;
  // const [selectedEntity, setSelectedEntity] =
  return React.createElement(My.Container, {
    selectedIndex: selectedIndex,
    className: cls.name(className)
  }, React.createElement(CircleMenu, {
    startAngle: -90,
    rotationAngle: 360,
    itemSize: size / 16,
    radius: radius,
    onMenuToggle: handleToggle,
    menuToggleElement: React.createElement(Count, {
      entityTypeName: entityTypeName,
      size: size,
      count: items.length,
      hoverColor: 'canvas'
    }),
    /**
     * rotationAngleInclusive (default true)
     * Whether to include the ending angle in rotation because an
     * item at 360deg is the same as an item at 0deg if inclusive.
     * Leave this prop for angles other than 360deg unless otherwise desired.
     */
    rotationAngleInclusive: false
  }, items.map(function (entity) {
    var isSelected = selectedEntity && selectedEntity.id === entity.id;
    var MarkerComponent = Markers[entityTypeName] || EntityMapMarker;
    return React.createElement(CircleMenuItem, {
      key: entity.id,
      onClick: onSelect && function () {
        onSelect(entity);
      },
      tooltip: null,
      size: size,
      style: {
        padding: 0,
        position: 'relative',
        zIndex: isSelected ? 100 : 99,
        border: 'none',
        background: 'none',
        transition: '0.3s all'
      }
    }, React.createElement(My.MenuItem, {
      isSelected: isSelected
    }, isSelected && React.createElement(My.PopupContainer, null, React.createElement(My.Popup, {
      size: size,
      onClose: onClose
    }, popup)), React.createElement(MarkerComponent, {
      isSelected: isSelected,
      size: size,
      pinSize: pinSize,
      entity: entity,
      imageStyle: imageStyle
    })));
  })));
};
EntityCircleMenu.defaultProps = EntityCircleMenuDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;